import React from 'react'
import './themesActivity.scss'

import personaje from '../../../assets/images/home/ansiedad.png'
import logo from '../../../assets/images/home/Vive_el_cole_Nol.png'
import useMediaQuery from '../../../utils/useMediaQuery'

const ThemesActivity = () => {
  const isMobile = useMediaQuery()
  return (
    <section className='f-section-themes'>
      <div className='f-section-themes__img-1'>
        <img src={logo} />
      </div>
      <div className='f-section-themes__theme-1'>
        <h3>1</h3>
        <p>Conoce los cambios del cuerpo durante la pubertad.</p>
      </div>
      <div className='f-section-themes__theme-2'>
        <h3>2</h3>
        <p>Aprende qué es el ciclo menstrual y sus etapas.</p>
      </div>
      <div className='f-section-themes__theme-3'>
        <h3>3</h3>
        <p>Te contamos sobre la higiene femenina.</p>
      </div>
      <div className='f-section-themes__theme-4'>
        <h3>4</h3>
        <p>
          {isMobile
            ? 'Conoce los productos Nosotras y elige el ideal para ti.'
            : 'Existen productos Nosotras para cada etapa del ciclo menstrual. Conoce sus características y elige el producto ideal para ti.'}
        </p>
      </div>
      <div className='f-section-themes__img-2'>
        <img src={personaje} />
      </div>
    </section>
  )
}

export default ThemesActivity
